// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
  max-width: 100%;
}
.du-review {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
.du-docs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 10px;
  border-bottom: 1px solid #ededed;
  margin-bottom: 12px;
}
.du-docs-title {
  font-size: 0.85rem;
  font-weight: 700;
  color: #171717;
}
.du-sub {
  margin-bottom: 12px;
}
.du-sub:last-child {
  margin-bottom: 16px;
}
.du-stub-card {
  background: #fff;
  border: 1px solid #ededed;
  border-radius: 12px;
  padding: 14px 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  transition: box-shadow 120ms ease;
}
.du-stub-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.du-stub-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 10px;
}
.du-stub-info {
  min-width: 0;
  flex: 1;
}
.du-stub-name {
  font-weight: 700;
  font-size: 0.88rem;
  color: #171717;
}
.du-stub-period {
  font-size: 0.78rem;
  color: #a3a3a3;
  margin-top: 2px;
}
.du-stub-file {
  font-size: 0.7rem;
  color: #a3a3a3;
  margin-top: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 260px;
}
.du-stub-amounts {
  text-align: right;
  flex-shrink: 0;
}
.du-stub-gross {
  font-weight: 700;
  font-size: 0.92rem;
  color: #171717;
}
.du-stub-net {
  font-size: 0.75rem;
  color: #a3a3a3;
  margin-top: 1px;
}
.du-stub-auth {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 6px;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.du-auth-pass {
  background: #dcfce7;
  color: #16a34a;
}
.du-auth-warn {
  background: #fff7ed;
  color: #ea580c;
}
.du-auth-fail {
  background: #fef2f2;
  color: #dc2626;
}
.du-stub-signals {
  margin-bottom: 10px;
  padding: 8px 10px;
  background: #fef2f2;
  border-radius: 6px;
  border-left: 3px solid #dc2626;
}
.du-signal {
  font-size: 0.75rem;
  color: #dc2626;
  padding: 2px 0;
  line-height: 1.4;
}
.du-signal strong {
  font-weight: 700;
}
.du-download-btn {
  font-size: 0.78rem;
  font-weight: 600;
  background: #fafafa;
  border: 1px solid #ededed;
  border-radius: 6px;
  padding: 5px 12px;
  cursor: pointer;
  color: #171717;
  transition: background 120ms ease, border-color 120ms ease;
}
.du-download-btn:hover:not(:disabled) {
  background: #f5f5f5;
  border-color: #a3a3a3;
}
.du-download-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.du-frequency-field,
.du-unsupported-fields {
  margin-bottom: 0.75rem;
}
.du-frequency-label,
.du-form-label {
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.25rem;
}
.du-form-optional {
  font-weight: 400;
  color: #6c757d;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/income-wizard/phases/stream-phase/stream-types/stream-review-docupload.component.less"],"names":[],"mappings":"AAcA;EACE,cAAA;EACA,WAAA;EACA,eAAA;AAbF;AAgBA;EACE,WAAA;EACA,eAAA;EACA,sBAAA;AAdF;AAiBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,gCAAA;EACA,mBAAA;AAfF;AAkBA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AAhBF;AAmBA;EACE,mBAAA;AAjBF;AAkBE;EAAe,mBAAA;AAfjB;AAkBA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;EACA,iCAAA;AAhBF;AAkBE;EAAU,yCAAA;AAfZ;AAkBA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAhBF;AAmBA;EAAgB,YAAA;EAAc,OAAA;AAf9B;AAiBA;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;AAfF;AAkBA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AAhBF;AAmBA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAjBF;AAoBA;EACE,iBAAA;EACA,cAAA;AAlBF;AAqBA;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;AAnBF;AAsBA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AApBF;AAwBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;AAtBF;AAyBA;EAAgB,mBAAA;EAAqB,cAAA;AArBrC;AAsBA;EAAgB,mBAAA;EAAqB,cAAA;AAlBrC;AAmBA;EAAgB,mBAAA;EAAqB,cAAA;AAfrC;AAkBA;EACE,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;AAhBF;AAmBA;EACE,kBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AAjBF;AAaA;EAMW,gBAAA;AAhBX;AAoBA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,0DAAA;AAlBF;AAoBE;EACE,mBAAA;EACA,qBAAA;AAlBJ;AAoBE;EAAa,YAAA;EAAc,mBAAA;AAhB7B;AAmBA;;EAEE,sBAAA;AAjBF;AAoBA;;EAEE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AAlBF;AAqBA;EACE,gBAAA;EACA,cAAA;AAnBF","sourcesContent":["// UDS-inspired tokens\n@uds-blue-70: #005ff0;\n@uds-green-70: #16a34a;\n@uds-red-70: #dc2626;\n@uds-orange-70: #ea580c;\n@uds-neutral-10: #fafafa;\n@uds-neutral-20: #f5f5f5;\n@uds-neutral-30: #ededed;\n@uds-neutral-50: #a3a3a3;\n@uds-neutral-100: #171717;\n@uds-radius: 12px;\n@uds-radius-sm: 6px;\n@uds-ease: 120ms ease;\n\n:host {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n}\n\n.du-review {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.du-docs-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 0 10px;\n  border-bottom: 1px solid @uds-neutral-30;\n  margin-bottom: 12px;\n}\n\n.du-docs-title {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: @uds-neutral-100;\n}\n\n.du-sub {\n  margin-bottom: 12px;\n  &:last-child { margin-bottom: 16px; }\n}\n\n.du-stub-card {\n  background: #fff;\n  border: 1px solid @uds-neutral-30;\n  border-radius: @uds-radius;\n  padding: 14px 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  transition: box-shadow @uds-ease;\n\n  &:hover { box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); }\n}\n\n.du-stub-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.du-stub-info { min-width: 0; flex: 1; }\n\n.du-stub-name {\n  font-weight: 700;\n  font-size: 0.88rem;\n  color: @uds-neutral-100;\n}\n\n.du-stub-period {\n  font-size: 0.78rem;\n  color: @uds-neutral-50;\n  margin-top: 2px;\n}\n\n.du-stub-file {\n  font-size: 0.7rem;\n  color: @uds-neutral-50;\n  margin-top: 3px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 260px;\n}\n\n.du-stub-amounts {\n  text-align: right;\n  flex-shrink: 0;\n}\n\n.du-stub-gross {\n  font-weight: 700;\n  font-size: 0.92rem;\n  color: @uds-neutral-100;\n}\n\n.du-stub-net {\n  font-size: 0.75rem;\n  color: @uds-neutral-50;\n  margin-top: 1px;\n}\n\n// ── Authenticity ──\n.du-stub-auth {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: @uds-radius-sm;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.du-auth-pass { background: #dcfce7; color: @uds-green-70; }\n.du-auth-warn { background: #fff7ed; color: @uds-orange-70; }\n.du-auth-fail { background: #fef2f2; color: @uds-red-70; }\n\n// ── Fraud signals ──\n.du-stub-signals {\n  margin-bottom: 10px;\n  padding: 8px 10px;\n  background: #fef2f2;\n  border-radius: @uds-radius-sm;\n  border-left: 3px solid @uds-red-70;\n}\n\n.du-signal {\n  font-size: 0.75rem;\n  color: @uds-red-70;\n  padding: 2px 0;\n  line-height: 1.4;\n\n  strong { font-weight: 700; }\n}\n\n// ── Download ──\n.du-download-btn {\n  font-size: 0.78rem;\n  font-weight: 600;\n  background: @uds-neutral-10;\n  border: 1px solid @uds-neutral-30;\n  border-radius: @uds-radius-sm;\n  padding: 5px 12px;\n  cursor: pointer;\n  color: @uds-neutral-100;\n  transition: background @uds-ease, border-color @uds-ease;\n\n  &:hover:not(:disabled) {\n    background: @uds-neutral-20;\n    border-color: @uds-neutral-50;\n  }\n  &:disabled { opacity: 0.5; cursor: not-allowed; }\n}\n\n.du-frequency-field,\n.du-unsupported-fields {\n  margin-bottom: 0.75rem;\n}\n\n.du-frequency-label,\n.du-form-label {\n  display: block;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #495057;\n  margin-bottom: 0.25rem;\n}\n\n.du-form-optional {\n  font-weight: 400;\n  color: #6c757d;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
